import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WheelService } from '../wheel.service';
import { WheelColor } from '../interfaces/wheel.interface';

@Component({
  selector: 'app-wheel-history',
  templateUrl: './wheel-history.component.html',
  styleUrls: ['./wheel-history.component.scss'],
  standalone: true,
  host: {
    class: 'box-black-third rounded-6',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WheelHistoryComponent {
  public readonly wheelService = inject(WheelService);
  public readonly colors: WheelColor[] = ['gray', 'red', 'blue', 'gold'];
}
